import { groupSizes } from "../helpers/group";

webix.protoUI(
	{
		name: "ssheet-group-intersection",
		defaults: {
			width: 0,
			height: 0,
			hidden: true,
		},
		$init() {
			this.$view.className += " webix_ssheet_group_intersection";
		},
		ready() {
			const view = this.getTopParentView();
			view.attachEvent("onZoom", () => this.render());
		},
		render() {
			const view = this.getTopParentView();
			if (!view) return;

			const colGroups = view._col_groups;
			const rowGroups = view._row_groups;

			const hasColGroups = colGroups && colGroups.length > 0;
			const hasRowGroups = rowGroups && rowGroups.length > 0;

			// intersection is only visible when both row and column groups are present
			// individual group visibility does not matter (hidden groups still take up space)
			if (!hasColGroups || !hasRowGroups) {
				this.hide();
				return;
			}

			this.show();

			const rowMaxLevel = view._row_groups_max_level;
			const zoom = view._zoom;
			const width = (rowMaxLevel + 1) * groupSizes.levelSize * zoom;

			if (this.config.width !== width) {
				this.define("width", width);
				this.resize();
			}
		},
	},
	webix.ui.view
);
